(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.nav || '(min-width: 1024px)').matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.nav || '(min-width: 1024px)').matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  /* "Information" disclosure — outside-click close, Escape close, AND
     dynamic positioning of the dropdown panel.

     The panel uses position: fixed because an ancestor
     <details class="main-menu__disclosure"> has overflow: hidden which
     would clip an absolute-positioned panel even with high z-index.
     Fixed positioning escapes the clip entirely, but means we lose the
     natural "right under the toggle" placement that absolute gave us
     — so we set top/right via JS from the summary's bounding rect on
     open, on resize, and on scroll while open.

     Idempotent under re-render: the wiring guard prevents
     double-attachment if the section re-renders. */
  if (!window.__omnitubInfoMenuWired) {
    window.__omnitubInfoMenuWired = true;

    function reposition(details) {
      const summary = details.querySelector('summary');
      const panel   = details.querySelector('.secondary-nav-disclosure__panel');
      if (!summary || !panel) return;
      const r = summary.getBoundingClientRect();
      panel.style.top   = (r.bottom + 8) + 'px';
      panel.style.right = Math.max(8, window.innerWidth - r.right) + 'px';
    }

    function repositionAllOpen() {
      document.querySelectorAll('details.secondary-nav-disclosure[open]').forEach(reposition);
    }

    // Reposition immediately when any <details> opens. The 'toggle' event
    // fires on every open/close — cheap, native, no polling.
    document.addEventListener('toggle', function (e) {
      if (!e.target.matches || !e.target.matches('details.secondary-nav-disclosure')) return;
      if (e.target.open) reposition(e.target);
      // Flag the open state so the sticky jump-nav can drop BEHIND the panel
      // (the panel is trapped in the header's stacking context, so we lower the
      // jump-nav rather than raise the panel). See omnitub-jumpnav.liquid.
      document.documentElement.classList.toggle('omn-info-open',
        !!document.querySelector('details.secondary-nav-disclosure[open]'));
    }, true);

    // Keep the panel pinned to the toggle on resize / scroll. Cheap because
    // it's a single function call per event, and scroll is passive.
    window.addEventListener('resize', repositionAllOpen);
    window.addEventListener('scroll', repositionAllOpen, { passive: true });

    // Outside click → close any open panel.
    document.addEventListener('click', function (e) {
      document.querySelectorAll('details.secondary-nav-disclosure[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    // Escape key → close.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('details.secondary-nav-disclosure[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    });
  }

  /* ── MOBILE NAV FIX (19 Aug 2026 — behaviour SUPERSEDED 24 Sep, see the note below) ──
     A top-level menu item that has a child menu renders as
       <details><summary class="js-toggle">
         <a class="main-nav__item--primary" href="/collections/…"> … </a>
       </summary> …
     On touch WebKit (iPhone) a tap on that summary performs the native
     <details> disclosure toggle and swallows the nested link, so the
     collection never loads — the drawer just expands / holds. The theme's
     own nav handler (assets/main.js › MainMenu.handleNavClick) deliberately
     bails on mobile for these anchors and does NOT preventDefault, so the
     broken native toggle is what the customer gets. ~67% of traffic is
     mobile, so this silently sinks the top-of-funnel tap.

     Fix: on mobile widths, any tap anywhere on a top-level parent summary
     goes straight to that item's own href (its collection / landing) —
     "touch it and go into the collection". Capture phase so we win over
     both the native toggle and the bubble-phase nav handler.

     Scope guards (do NOT regress anything else):
       • min-width:768px → return  ⇒ desktop hover mega-nav untouched.
       • only summary.js-toggle (top-level) matches; child summaries use
         js-no-toggle-md, the Resources disclosure uses its own class, and
         the Shop/Tools pills (data-omn-mobile-pills) are radios — none match.
       • child links, the "Back" button and the mobile header link are not
         inside a summary.js-toggle, so they keep working. */
  /* 24 Sep 2026 — PARENTS WITH CHILDREN OPEN THEIR SUB-MENU (supersedes the 19 Aug "always navigate").
     "Baths" gained children (All baths · Outdoor baths); sending every tap straight to /collections/
     deep-bathtubs made the children unreachable on a phone. Now, under 768px, a tap anywhere on a
     top-level summary.js-toggle row — the label OR its chevron — runs the theme's OWN sub-menu open
     path (MainMenu.handleNavClick with the summary as target: slide-in child nav, Back button, focus
     handling), so it behaves exactly like the theme intended, and never the flaky native <details>
     toggle that ff9f434 fixed. The parent's own page is still one tap away: the child nav's first row
     is the parent link (.main-nav__item-header, md:hidden), and "Baths" also lists "All baths".
     Items WITHOUT children render as plain links (no summary.js-toggle) and are untouched. Fallback:
     if the theme menu class isn't available, keep the 19 Aug behaviour (go to the item's href). */
  if (!window.__omnitubMobileNavFixWired) {
    window.__omnitubMobileNavFixWired = true;
    document.addEventListener('click', function (e) {
      if (window.matchMedia('(min-width: 1024px)').matches) return;          // desktop (one-row nav) → leave alone; the drawer owns <1,024 (25 Sep 2026)
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (!e.target || !e.target.closest) return;
      var summary = e.target.closest('summary.js-toggle');                   // top-level parent only
      if (!summary) return;
      var details = summary.closest('details');
      var menu = summary.closest('main-menu');
      var hasChildren = !!(details && details.querySelector('.child-nav a[href]:not(.main-nav__item-header)'));
      var Menu = (typeof MainMenu !== 'undefined') ? MainMenu : (window.customElements && customElements.get('main-menu'));
      if (hasChildren && menu && Menu && typeof Menu.handleNavClick === 'function') {
        e.preventDefault();            // no native <details> toggle, no link follow
        e.stopImmediatePropagation();  // the theme handler runs once, below, with the summary as target
        try {
          Menu.handleNavClick.call(menu, { target: summary, preventDefault: function () {} });
          return;
        } catch (err) { /* fall through to the 19 Aug behaviour */ }
      }
      var a = summary.querySelector('a.main-nav__item--primary[href]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;                           // ignore placeholder toggles
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.assign(a.href);
    }, true);
  }

  /* ── Desktop mega-menu: one "Menu" trigger → full-width drop panel ─────────
     A plain button with an explicit open/close state — NOT a <details>. The
     old Help disclosure was a <details> that a click both toggled AND the
     document click-away handler closed, so it flickered / vanished on click.
     Here the button's own click calls stopPropagation, and the click-away
     handler ignores clicks on the button and inside the panel, so open/close
     is always a single deterministic action. Escape closes; idempotent guard
     prevents double-wiring if the section re-renders in the theme editor. */
  if (!window.__omnMegaWired) {
    window.__omnMegaWired = true;
    var omnMegaBtn = document.getElementById('omn-mega-btn');
    var omnMega    = document.getElementById('omn-mega');
    var omnMegaBd  = document.getElementById('omn-mega-backdrop');
    if (omnMegaBtn && omnMega) {
      var omnMegaOpen = function () {
        omnMega.classList.add('is-open');
        if (omnMegaBd) omnMegaBd.classList.add('is-open');
        omnMegaBtn.setAttribute('aria-expanded', 'true');
      };
      var omnMegaClose = function () {
        omnMega.classList.remove('is-open');
        if (omnMegaBd) omnMegaBd.classList.remove('is-open');
        omnMegaBtn.setAttribute('aria-expanded', 'false');
      };
      omnMegaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        (omnMegaBtn.getAttribute('aria-expanded') === 'true') ? omnMegaClose() : omnMegaOpen();
      });
      // Clicks inside the panel must not bubble to the document click-away handler.
      omnMega.addEventListener('click', function (e) { e.stopPropagation(); });
      if (omnMegaBd) omnMegaBd.addEventListener('click', omnMegaClose);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && omnMegaBtn.getAttribute('aria-expanded') === 'true') omnMegaClose();
      });
      document.addEventListener('click', function (e) {
        if (omnMegaBtn.getAttribute('aria-expanded') !== 'true') return;
        if (omnMega.contains(e.target) || omnMegaBtn.contains(e.target)) return;
        omnMegaClose();
      });
    }
  }

  /* ── One-row nav safety net (25 Sep 2026, cross-device audit Wave 1) ──────────
     The nav never wraps. If it is ever wider than its centre track (a longer label, a
     translated menu), mark it .omn-nav-overflow so the CSS turns it into a sideways
     scroller with a fade on the clipped edge, instead of spilling into the logo or icons.
     Re-measured on resize, after fonts load, and whenever the row changes size. */
  if (!window.__omnNavOverflowWired) {
    window.__omnNavOverflowWired = true;
    (function () {
      var mq = window.matchMedia('(min-width: 1024px)');
      function nav() { return document.querySelector('.header__grid.omn-1row .main-nav'); }
      function atEnd(ul) { ul.classList.toggle('is-at-end', ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 2); }
      function check() {
        var ul = nav(); if (!ul) return;
        if (!mq.matches) { ul.classList.remove('omn-nav-overflow', 'is-at-end'); return; }
        var over = ul.scrollWidth > ul.clientWidth + 1;
        ul.classList.toggle('omn-nav-overflow', over);
        if (over) atEnd(ul); else ul.classList.remove('is-at-end');
      }
      function wire() {
        var ul = nav(); if (!ul) return;
        check();
        ul.addEventListener('scroll', function () { atEnd(ul); }, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(check).observe(ul);
        window.addEventListener('resize', check);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
        window.addEventListener('load', check);
      }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
    })();
  }

  /* ── Wave 2 (25 Sep 2026): chip rail edge fade + the "Sale" nav item/chip ───────────
     Sale opens the promotions bar's offer panel (same as tapping the bar); if the bar isn't
     on the page the link simply navigates. Both hide when the sale ends client-side. */
  if (!window.__omnWave2NavWired) {
    window.__omnWave2NavWired = true;
    (function () {
      function wire() {
        var rail = document.querySelector('.omn-rail__list');
        if (rail) {
          var end = function () { rail.classList.toggle('is-at-end', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2); };
          rail.addEventListener('scroll', end, { passive: true }); window.addEventListener('resize', end); end();
          var cur = rail.querySelector('[aria-current="page"]');
          if (cur && cur.scrollIntoView) { try { rail.scrollLeft = Math.max(0, cur.parentNode.offsetLeft - 24); } catch (e) {} }
        }
        document.addEventListener('click', function (e) {
          var a = e.target && e.target.closest && e.target.closest('[data-omn-sale-open]'); if (!a) return;
          var tg = document.querySelector('[data-sbs-pbar-toggle]');
          if (!tg || !tg.offsetParent) return;                               // no bar → follow the link
          e.preventDefault();
          var bar = tg.closest('[data-sbs-pbar]');
          if (!bar || !bar.classList.contains('is-open')) tg.click();
          var wrap = tg.closest('.shopify-section'); if (wrap) wrap.classList.remove('sbs-bar-away');
        });
        document.addEventListener('sbs:ended', function () {
          document.querySelectorAll('[data-omn-sale-item]').forEach(function (li) { li.remove(); });
        });
      }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
    })();
  }

  } catch(e) { console.error(e); }
})();
})();
